import Axios, { AxiosResponse, AxiosError } from "axios";
const API = Axios.create();
API.interceptors.response.use(
  (response: AxiosResponse): AxiosResponse => {
    const stored = localStorage.getItem("API_TIME");
    const apitime = stored ? new Date(stored) : new Date();
    const endDate = new Date();
    const seconds = (endDate.getTime() - (apitime?.getTime() || new Date().getTime())) / 1000;

    if (60 * 60 < seconds) {
      localStorage.clear();
      if (!window.location.href.includes("signin")) {
        window.location.replace("/signin");
      }
    } else {
      localStorage.setItem("API_TIME", new Date().toString());
    }
    return response;
  },
  (error: AxiosError): Promise<never> => {
    // error.response is undefined for cancelled/aborted requests (rapid page
    // navigation) and for network/throttle failures where API Gateway returns a
    // 5xx with no CORS header. Reading `.status` off undefined here threw a
    // TypeError INSIDE the interceptor, which cascaded into broken UI states
    // ("invoice does not exist", missing KVP lines). Guard it so the original
    // error propagates and each caller's catch can degrade gracefully.
    const status = error.response?.status;
    if (status === 401) {
      localStorage.clear();
      if (!window.location.href.includes("signin")) {
        window.location.replace("/signin");
      }
    }
    return Promise.reject(error);
  }
);
export default API;
